export interface FileInfo {
  name: string;
  size: number;
  updated: string;
  content_type: string;
}

export async function fetchFiles(): Promise<FileInfo[]> {
    const retrieveFileURL =
    (window as any)?.data?.retrieve?.retrieveFileURL || '';
  const res = await fetch(retrieveFileURL);
  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }
  const data = await res.json();
  if (Array.isArray(data)) {
    return data;
  } else if (data.files && Array.isArray(data.files)) {
    return data.files;
  } else if (data.error) {
    throw new Error(data.error);
  } else {
    return [];
  }
}